import * as axios from '~/utilities/axios'

export const createToFight = (body, sessionToken) => {
  if (!body.telemetry) {
    body.telemetry = {
      origin_create: 'v2 web app'
    }
  }
  return axios.secure(sessionToken)
    .post('/api/v1/parkingticket/flow/toFight', body)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const createToPay = (body, sessionToken) => {
  if (!body.telemetry) {
    body.telemetry = {
      origin_create: 'v2 web app'
    }
  }
  return axios.secure(sessionToken)
    .post('/api/v1/parkingticket/flow/toPay', body)
    .then(res => res.data)
    .catch(axios.parseError)
}